<template>
  <select :name="name" :id="id" @change="handleChange" v-model="internalValue">
    <option value="" disabled>{{ placeholder }}</option>
    <option v-for="(op, index) in options" :key="index" :value="op.value || op">{{ op.name || op }}</option>
  </select>
</template>

<script>
export default {
  props: ['name', 'id', 'options', 'placeholder', 'passSelectedValue', 'value'],
  data() {
    return {
      internalValue: this.value || '',
    };
  },
  watch: {
    value(newValue) {
      console.log('newValue', newValue);
      this.internalValue = newValue;
    },
  },
  methods: {
    handleChange() {
      if (this.passSelectedValue) {
        this.$emit('onSelectedValue', this.internalValue);
      } else {
        this.$emit('changeSelect', this.id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~varmix';

select {
  height: 47px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  -webkit-border-radius: 0px;
  -moz-border-radius: 0px;
  width: 100%;
  padding: 10px;
  background-color: transparent;
  border: none;
  border-bottom: 2px solid $inactive;
}

select {
  background-image: linear-gradient(45deg, transparent 50%, $inactive 50%),
  linear-gradient(135deg, $inactive 50%, transparent 50%),
  linear-gradient(to right, #cccccc, #ccc);
  background-position: calc(100% - 20px) calc(1em + 2px),
  calc(100% - 15px) calc(1em + 2px),
  calc(100% - 2.5em) 0.5em;
  background-size: 5px 5px,
  5px 5px,
  1px 1.5em;
  background-repeat: no-repeat;
}

select:focus {
  background-image: linear-gradient(45deg, $amarilloC 50%, transparent 50%),
  linear-gradient(135deg, transparent 50%, $amarilloC 50%),
  linear-gradient(to right, #ccc, #ccc);
  background-position: calc(100% - 15px) 1em,
  calc(100% - 20px) 1em,
  calc(100% - 2.5em) 0.5em;
  background-size: 5px 5px,
  5px 5px,
  1px 1.5em;
  background-repeat: no-repeat;
  border-color: $amarilloC;
  outline: 0;
}


select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #000;
}
</style>



// WEBPACK FOOTER //
// Select.vue?8368b3a0